import React, {useEffect, useState} from "react"
import {RouteComponentProps} from "react-router-dom"

import authentication from "@irati/auth"
import tracking from "@irati-tracking/perks/perks"
import redemptionService from "@irati/checkout/services/redemptions"
import {CheckoutRedemption, Deal} from "@irati/types"
import Flex from "@irati/ui/src/Flex"
import Loading from "@irati/ui/src/Loading"
import {Content} from "../components/CheckoutSuccess/Content"
import {Cta} from "../components/CheckoutSuccess/Cta"
import OrderInfoSection from "../components/CheckoutSuccess/OrderInfoSection/OrderInfoSection"
import {OrderNotFound} from "../components/CheckoutSuccess/OrderNotFound"

type Props = RouteComponentProps<{redemptionId: string}> & {
  deal: Required<Deal>
}

const MerchandiseSuccess = ({match, deal}: Props) => {
  const [redemptionState, setRedemptionState] = useState<CheckoutRedemption>()
  const [load, setLoad] = useState<Promise<CheckoutRedemption>|null>(null)
  const {redemptionId} = match.params

  const getOrder = async() => {
    const promise = redemptionService.get(redemptionId)
    setLoad(promise)

    const order = await promise
    setRedemptionState(order)
  }

  useEffect(() => {
    if(redemptionId) {
      getOrder()
    }
  }, [redemptionId])

  useEffect(() => {
    if(redemptionState) {
      tracking.redeemPerkFinishSuccess(deal)
    }
  }, [redemptionState])

  if (!redemptionState) return <Loading load={load} Error={() => <OrderNotFound />} />

  const {email} = authentication.user()
  const {order: {products, basket}} = redemptionState as Required<CheckoutRedemption>

  return (
    <Flex direction="column" margin="0 auto" maxWidth="634px">
      <Content userEmail={email!} />
      <Cta />
      <OrderInfoSection uuid={products![0].items![0].code!} basket={basket!} cardImage={deal.cardImage} header={deal.header}  />
    </Flex>
  )
}

export default MerchandiseSuccess
